import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'block',
      flex: '1',
      marginBottom: SMALL_MARGIN,
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 5,
      height: 195,
      [theme.breakpoints.up('sm')]: {
        height: 274,
      },
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    lazyLoadWrapper: {
      width: '100%',
      height: '100%',
    },
  }),
);
export default useStyles;
